import type { FaireProductEntity } from "../../entity_types/product";

export const p_d33jmewj5r: FaireProductEntity = {
  token: "p_d33jmewj5r",
  type: "product",
  name: "Little Notes® Envelopes - Seaglass - Set of 20",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/b9b1ef0b281c41a740364af437bbf9c6b8751053a86f827626f56da6d6a153ec.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2b2d66bf8461ea3c14635914de5f1e11ab29f5c49b9221d3c35b428df9c81b15.jpeg",
    "https://cdn.faire.com/fastly/278fa30bb8dbea2f1b7b5ac697d1c6b384bcd958e56062f338f887011c1eb224.png",
    "https://cdn.faire.com/fastly/748ce27e6d2411b863d9bbf4fd059f0e3bc2a75b5842f3b2bb4c0b70b8138b33.jpeg",
    "https://cdn.faire.com/fastly/d3388bf5fa42487d77a49245c050cd4167bc583c6e75961e7dcdad3b1ef23c0b.jpeg",
  ],
  priceDollars: 5,
  description:
    "Round out your Little Notes® collection with our Little Notes® Envelopes: a set of 20 tiny envelopes, each just the right size for a single Little Note. Perfect for a tip, a secret note, or to add a gummy bear to sweeten the love. These petite envelopes turn every Little Note into a secret surprise.\n\nPlease note: These envelopes are so adorably tiny that they're too small for the postal service, so hand-deliver only!",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:01.128Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
